import React from 'react';
import './Blogs.css';
import Blog1 from '../../images/blog/1.jpg';
import Blog2 from '../../images/blog/2.jpg';
import Blog3 from '../../images/blog/3.jpg';
import BubblesParticlesBackground from '../ParticlesBackground/BubblesParticlesBackground';

const blogData = [
    {
        id: 1,
        title: 'JavaScript Question',
        date: '9 May 2021',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore, porro rem quod illo quam, eum alias id, repellendus magni, quas.',
        tags: 'JavaScript',
        image: Blog1,
        url: 'https://imsamrat24.medium.com/most-javascript-question-c1b81077f0e0'
    }, {
        id: 2,
        title: 'React Basic',
        date: '8 May 2021',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore, porro rem quod illo quam, eum alias id, repellendus magni, quas.',
        tags: 'React',
        image: Blog2,
        url: 'https://imsamrat24.medium.com/important-topics-in-9f059ad61230'
    }, {
        id: 3,
        title: 'Node Basic',
        date: '6 May 2021',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore, porro rem quod illo quam, eum alias id, repellendus magni, quas.',
        tags: 'JavaScript',
        image: Blog3,
        url: 'https://imsamrat24.medium.com/you-must-know-10-topics-in-javascript-736ec544bab5'
    }
]

const Blogs = () => {
    return (
        <>
            <div className="particles-bg">
                {/* <BubblesParticlesBackground /> */}
            </div>
            <section id="blog" className="blog section">
                <div className="container">
                    <div className="row">
                        <div className="section-title padd-15">
                            <h2>Latest Blog</h2>
                        </div>
                    </div>
                    <div className="row">
                        {
                            blogData.map(blog => <div key={blog.id} className="blog-box padd-15">
                                <a href={blog.url} target="_blank">
                                <div className="blog-item shadow-dark">
                                    <div className="blog-img">
                                        <img src={blog.image} alt="blog" />
                                        <div className="blog-date">
                                            {blog.date}
                                        </div>
                                    </div>
                                    <div className="blog-info">
                                        <h4 className="blog-title">{blog.title}</h4>
                                        <p className="blog-description">{blog.description}</p>
                                        <p className="blog-tags">Tags : <span>{blog.tags}</span></p>
                                    </div>
                                </div>
                                </a>
                            </div>)
                        }
                    </div>
                </div>
            </section>
        </>
    );
};

export default Blogs;